export default goal => {
  const statusPriorityMap = {
    'on-track': 1,
    behind: 2,
    'at-risk': 3
  }
  let current = 'on-track'
  goal.keyResults
    .filter(kr => (goal.isArchived ? true : !kr.isArchived))
    .forEach(kr => {
      let currentPriority = statusPriorityMap[current]
      let krStatusPriority = statusPriorityMap[kr.status]
      if (krStatusPriority > currentPriority) {
        current = kr.status
      }
    })
  return current
}
